import { useEffect } from 'react'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import { useLocation, useNavigate } from 'react-router-dom'
import { SignUpReason, useSignUpAttribution } from '../useSignUpAttribution/useSignUpAttribution'

export const useIsGrantsOnboarding = () => {
  const { signUpAttribution } = useSignUpAttribution()

  return signUpAttribution?.reason === SignUpReason.GRANTS_ONBOARDING
}

export const useGrantsAttributionRedirect = () => {
  const isGrantsOnboarding = useIsGrantsOnboarding()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (isGrantsOnboarding) {
      const searchParams = new URLSearchParams(location.search)

      if (searchParams.get('next') !== RoutePath.GRANTS) {
        searchParams.set('next', RoutePath.GRANTS)
        navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true, state: location.state })
      }
    }
  }, [location, isGrantsOnboarding, navigate])
}
